import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const updateEvent = createAsyncThunk(
  "schedule/event",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateEvent(data.data, data.type, data.tab)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const updateEventSlice = createSlice({
  name: "updateEvent",
  initialState,
  reducers: {
    clearUpdateEventResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateEvent.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const eventResponse = (state) => {
	return state.updateEvent.value
};
export const {clearUpdateEventResponse} = updateEventSlice.actions;

export default updateEventSlice.reducer;
